var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from '../../styled/index';
import { media } from '../../themes/breakpoint';
const Navbar = styled.div `
  padding: 0.3125rem 2rem;
  background-color: ${({ theme, backgroundColor }) => theme.colors[backgroundColor]};
  color: ${({ theme, fontColor }) => theme.colors[fontColor]};
  z-index: ${({ theme }) => theme.zIndex.ContextualBar};
  ${media.mobile `
    padding: 0.5rem 1rem;
  `};
`;
const Container = styled.div `
  max-width: 61rem;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;
const Content = styled.div `
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const IconWrapper = styled.div `
  padding-right: 0.5rem;
  line-height: 0;

  ${media.mobile `
    padding-right: 0.25rem;
  `};
`;
const MessageWrapper = styled.div `
  flex: 1;
  padding-right: 1rem;

  ${media.mobile `
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  `};
`;
const OptionsWrapper = styled.div `
  > *:not(:last-child) {
    margin-right: 0.5rem;
  }
`;
const ContextualBar = (_a) => {
    var { Icon, backgroundColor = 'PRIMARY_700', fontColor = 'SNOW_100', message, renderOptions } = _a, restProps = __rest(_a, ["Icon", "backgroundColor", "fontColor", "message", "renderOptions"]);
    return (React.createElement(Navbar, Object.assign({ backgroundColor: backgroundColor, fontColor: fontColor }, restProps),
        React.createElement(Container, null,
            React.createElement(Content, null,
                Icon && (React.createElement(IconWrapper, null,
                    React.createElement(Icon, { size: "MEDIUM", color: fontColor }))),
                React.createElement(MessageWrapper, null, message)),
            renderOptions && React.createElement(OptionsWrapper, null, renderOptions()))));
};
export default ContextualBar;
//# sourceMappingURL=index.js.map